import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input, OnChanges,
    OnInit,
    Output, SimpleChanges
} from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subject, Subscription } from 'rxjs/index';
import { BsModalConfirmComponent, createConfirmModalOptions } from '../core/modal/modal-confirm.component';
import { AdaptiveRule } from './state/adaptive-rule.model';

@Component({
    selector: 'rule-controls',
    templateUrl: './rule-controls.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RuleControlsComponent implements OnInit, OnChanges {

    @Input() loading;
    @Input() userRules;
    @Input() selectedUserId;
    @Output() readonly ruleChanged: EventEmitter<any> = new EventEmitter<any>();
    @Output() readonly addedNew: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() readonly selectRuleChanged: EventEmitter<any> = new EventEmitter<any>();

    subscription: Subscription;
    selectedRule: AdaptiveRule;
    rule: AdaptiveRule;

    isUpdated = false;
    onClose: Subject<boolean>;
    isNewRule = false;

    constructor(private modalService: BsModalService) {
        this.selectedRule = undefined;
    }

    public clearRuleDetails(clearRule): void {
        this.rule = undefined;
        this.ruleChanged.emit(undefined);
        this.selectedRule = this.rule;
        this.selectRuleChanged.emit(undefined);
    }

    public addRule(): void {
        this.selectedRule = {
            ruleName: '',
            referenceKey: '',
            description: ' ',
            type: 'map',
            reference: undefined,
            mediaType: undefined
        };
        this.isNewRule = true;
        this.addedNew.emit(true);
    }

    updateRule(updatedRule: AdaptiveRule): void {
        if (updatedRule !== undefined) {
            this.userRules.map(userRule => {
                if (this.isNewRule) {
                    this.isUpdated = updatedRule.ruleName !== undefined &&
                        updatedRule.ruleName !== null && updatedRule.ruleName !== '';
                } else {
                    if (updatedRule.ruleName === userRule.ruleName) {
                        let isMapUpdated = false; // if value in map array is updated
                        updatedRule.map.findIndex(rule => {
                            const key = Object.keys(rule)[0];
                            const value = Object.values(rule)[0];
                            userRule.map.find(userrule => {
                                const userrulekey = Object.keys(userrule)[0];
                                const userrulevalue = Object.values(userrule)[0];
                                if (userrulekey === key) {
                                    isMapUpdated = userrulevalue !== value;
                                }
                            })
                        });
                        this.isUpdated = updatedRule.mediaType !== userRule.mediaType ||
                            updatedRule.default !== userRule.default || isMapUpdated ||
                            updatedRule.map.length !== userRule.map.length;
                    }
                }

                return userRule;
            });
            this.ruleChanged.emit(updatedRule);
        }
    }

    public resetRuleDetails(): void {
        if (this.isUpdated) {
            const modalRef = this.modalService
                .show(BsModalConfirmComponent, createConfirmModalOptions('Confirm',
                    'You will loose all unsaved changes. Are you sure you want to continue?',
                    'Yes', 'No'));

            modalRef.content.onClose
                .subscribe(dialogResult => {
                    if (dialogResult.isConfirmed) {
                        this.isUpdated = false;
                        this.onClose.next(dialogResult);
                        this.selectedRule = this.rule;
                        this.ruleChanged.emit(undefined);
                    } else {
                        this.rule = this.selectedRule;
                        this.addedNew.emit(false);
                    }
                });
        } else {
            this.selectedRule = this.rule;
        }
        this.addedNew.emit(false);
        this.selectRuleChanged.emit(this.selectedRule);
    }

    ngOnInit(): void {
        this.onClose = new Subject();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.userRules !== undefined) {
            this.selectedRule = undefined;
            this.selectRuleChanged.emit(this.selectedRule);
        }
    }
}
